
/* @ngInject */
export default function raCurrency($filter, $browser) {
    return {
        require: 'ngModel',

        // attributes on elements only (input/textarea)
        restrict: 'A',

        // link for DOM manipulation
        link($scope, $element, $attrs, ngModelCtrl) {
            const listener = function () {
                // $element.val($filter('currency')(getCleanValue($element.val()), '$', 0));
                $element.val(renderCurrencyFilter(getCleanValue($element.val()), $attrs));
            };

            // This runs when we update the text field
            ngModelCtrl.$parsers.push(viewValue => getCleanValue(viewValue));

            // This runs when the model gets updated on the scope directly and keeps our view in sync
            ngModelCtrl.$render = function () {
                // $element.val($filter('currency')(ngModelCtrl.$viewValue, '$', 0));
                if (ngModelCtrl.$viewValue) {
                    $element.val(renderCurrencyFilter(getCleanValue(ngModelCtrl.$viewValue), $attrs));
                }
            };

            $element.bind('change', listener);

            $element.bind('paste cut', () => {
                $browser.defer(listener);
            });

            // returns the decimal value or 0 if fails isNaN check
            function getCleanValue(value) {
                const cleanValue = parseFloat(value.replace(/,|\$/g, ''));
                return isNaN(cleanValue) ? 0 : cleanValue;
            }

            // using the attributes and the default currency filter - generates the currency as a string
            function renderCurrencyFilter(value) {
                const filterArgs = $attrs.raCurrency.split(':');

                const symbol = filterArgs[0] ? filterArgs[0] : '$';
                const fractionSize = filterArgs[1] ? filterArgs[1] : 0;

                return $filter('currency')(value, symbol, fractionSize);
            }
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/common/angular/directives/raCurrency.directive.js